import {EventDispatcher} from "../EventDispatcher.js";

export class ContextMenu extends EventDispatcher {
  constructor(viewer) {
    super();
    
    this.viewer = viewer;
    this.isVisible = false;
    this.currentMode = 'create'; // 'create' or 'move'
    this.menuElement = null;
    this.position = { x: 0, y: 0 };
    
    this.createMenuElement();
    this.setupEventListeners();
  }

  createMenuElement() {
    // Create the context menu HTML
    this.menuElement = document.createElement('div');
    this.menuElement.id = 'point-context-menu';
    this.menuElement.className = 'fixed bg-white border border-gray-300 rounded-lg shadow-lg z-50 min-w-48';
    this.menuElement.style.display = 'none';
    
    this.menuElement.innerHTML = `
      <div class="py-1">
        <div class="px-4 py-2 text-sm font-medium text-gray-700 border-b border-gray-200">
          Point Mode
        </div>
        <button id="context-create-point" class="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 flex items-center">
          <span class="w-3 h-3 rounded-full bg-green-500 mr-3"></span>
          <span>Create Point</span>
          <span class="ml-auto text-xs text-gray-500" id="create-indicator">●</span>
        </button>
        <button id="context-move-point" class="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 flex items-center">
          <span class="w-3 h-3 rounded-full bg-blue-500 mr-3"></span>
          <span>Move Point</span>
          <span class="ml-auto text-xs text-gray-500" id="move-indicator"></span>
        </button>
        <div class="border-t border-gray-200 my-1"></div>
        <button id="context-cancel" class="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 text-gray-600">
          Cancel
        </button>
      </div>
    `;
    
    document.body.appendChild(this.menuElement);
    this.setupMenuEventListeners();
  }

  setupMenuEventListeners() {
    const createBtn = this.menuElement.querySelector('#context-create-point');
    const moveBtn = this.menuElement.querySelector('#context-move-point');
    const cancelBtn = this.menuElement.querySelector('#context-cancel');

    createBtn.addEventListener('click', () => {
      this.setMode('create');
      this.hide();
    });

    moveBtn.addEventListener('click', () => {
      this.setMode('move');
      this.hide();
    });

    cancelBtn.addEventListener('click', () => {
      this.hide();
    });
  }

  setupEventListeners() {
    // Hide menu when clicking outside
    document.addEventListener('click', (e) => {
      if (this.isVisible && !this.menuElement.contains(e.target)) {
        this.hide();
      }
    });

    // Hide menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isVisible) {
        this.hide();
      }
    });
  }

  show(x, y) {
    this.position = { x, y };
    this.menuElement.style.left = `${x}px`;
    this.menuElement.style.top = `${y}px`;
    this.menuElement.style.display = 'block';
    this.isVisible = true;
    
    // Update visual indicators
    this.updateIndicators();
    
    this.dispatchEvent({ type: 'context_menu_shown', position: this.position });
  }

  hide() {
    this.menuElement.style.display = 'none';
    this.isVisible = false;
    this.dispatchEvent({ type: 'context_menu_hidden' });
  }

  setMode(mode) {
    console.log('ContextMenu: Setting mode to', mode);
    this.currentMode = mode;
    this.updateIndicators();
    console.log('ContextMenu: Dispatching mode_changed event with mode:', this.currentMode);
    this.dispatchEvent({ type: 'mode_changed', mode: this.currentMode });
  }

  updateIndicators() {
    const createIndicator = this.menuElement.querySelector('#create-indicator');
    const moveIndicator = this.menuElement.querySelector('#move-indicator');
    
    if (this.currentMode === 'create') {
      createIndicator.textContent = '●';
      moveIndicator.textContent = '';
    } else {
      createIndicator.textContent = '';
      moveIndicator.textContent = '●';
    }
  }

  getCurrentMode() {
    return this.currentMode;
  }

  dispose() {
    if (this.menuElement && this.menuElement.parentNode) {
      this.menuElement.parentNode.removeChild(this.menuElement);
    }
  }
}
